import {HttpClient} from '@angular/common/http';
import {ServiceBase} from '../base/service.base';
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {User} from '../model/user/user';

@Injectable({
    providedIn: 'root'
})
export class EnumService extends ServiceBase {

    constructor(http: HttpClient) {
        super(http);
    }

    // types { channel|measure|dispatched }
    getEnum(type) {
        const url = `${this.BASE_URL}/enum/${type}`;
        return this.http.get(url);
    }

}
